/**
 * The small flash on the Feed tab (owner, 2026-09-28): Kraben posts the
 * picture the moment you tap it, and the tab wears its thumbnail until you go
 * and look. Device-only, like the other "seen" marks; a day old, it lapses.
 */

const KEY = 'kindling.feed.new';
const LIFE_MS = 24 * 60 * 60 * 1000;

export interface FeedNew { url: string; at: number }

export function markPosted(url: string): void {
  try { localStorage.setItem(KEY, JSON.stringify({ url, at: Date.now() })); } catch { /* private mode: no flash */ }
  window.dispatchEvent(new Event(KEY));
}

export function feedNew(): FeedNew | null {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null') as FeedNew | null;
    return v && Date.now() - v.at < LIFE_MS ? v : null;
  } catch { return null; }
}

export function clearFeedNew(): void {
  try { localStorage.removeItem(KEY); } catch { /* nothing to clear */ }
  window.dispatchEvent(new Event(KEY));
}

/** Subscribes to changes made on this page, so a tab bar already on screen picks up a post. */
export function onFeedNew(fn: () => void): () => void {
  window.addEventListener(KEY, fn);
  return () => window.removeEventListener(KEY, fn);
}
